import React from "react";

import Edit from "./Edit";
import Create from "./Create";

const Entry = ({ props, match }) => {
  if (match.params.type === "edit") {
    return <Edit />;
  }
  if (match.params.type === "create") {
    return <Create />;
  }
};

export default Entry;



// WEBPACK FOOTER //
// ./src/containers/ActivityCategories/index.jsx